import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const bootstrapApplication = (): void => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
};

async function registerLogoProxyWorker(): Promise<void> {
  if (!environment.logoProxyWorkerEnabled || !('serviceWorker' in navigator)) return;

  const appBaseUrl = new URL(document.baseURI);
  const workerUrl = new URL('logo-proxy-worker.js', appBaseUrl);
  await navigator.serviceWorker.register(workerUrl.toString(), {
    scope: appBaseUrl.pathname,
  });
  await navigator.serviceWorker.ready;

  if (navigator.serviceWorker.controller) return;

  await new Promise<void>((resolve) => {
    const timeout = window.setTimeout(resolve, 3000);
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.clearTimeout(timeout);
      resolve();
    }, { once: true });
  });
}

registerLogoProxyWorker()
  .catch(error => console.error('Logo proxy service worker registration failed.', error))
  .finally(bootstrapApplication);
